// extracted by mini-css-extract-plugin
module.exports = {"content":"richText-module__content___22-AM"};